import { Link } from 'react-router-dom';
import './App.css';

function Impressum() {
    return (
        <div className="impressum-overlay">
            <div className="impressum-header">
                <Link to="/">
                    <img src="/2B55699D-C82C-4115-9771-14E9E64B1981.png" className="impressum-header-logo" alt="DEENACTIVE" />
                </Link>
            </div>
            <div className="impressum-content">
                <h1>Impressum</h1>

                <h2>Angaben gemäß § 5 TMG</h2>
                <p>
                    Deenactive UG (haftungsbeschränkt)
                    <br />
                    Westring 2<br />
                    33415 Verl
                    <br />
                    Deutschland
                </p>

                <h2>Vertretungsberechtigter Geschäftsführer</h2>
                <p>Nurettin Öcel</p>

                <h2>Kontakt</h2>
                <p>
                    Telefon: +49 151 74587524
                    <br />
                    E-Mail: deenactive[at]nurettinocel.de
                </p>

                <h2>Umsatzsteuer-ID</h2>
                <p>
                    Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG:
                    <br />
                    wird nachgereicht
                </p>

                <h2>Online-Streitbeilegung</h2>
                <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
                    <br />
                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
                        ec.europa.eu/consumers/odr
                    </a>
                </p>

                <h2>Verbraucherstreitbeilegung</h2>
                <p>
                    Zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle sind wir nicht verpflichtet und nicht
                    bereit.
                </p>
            </div>
        </div>
    );
}

export default Impressum;
